import React from 'react'
import { StyleSheet, View, Platform, Image } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

import { adaptive, backgroundColors, colors, typography } from '@sart/styles'
import { useContent } from '@sart/content'
import {
  Title,
  Description,
  Space
} from '@sart/components'
import AppConfig from '../Configuration/AppConfig';

export default function About(props) {
    const content = useContent()

    let osName;
    if(Platform.OS === "ios") {
      osName = "iOS"
    } else if (Platform.OS === "android") {
      osName = "Android"
    }

    return (
        <SafeAreaView>
            <View>
                <Space height={49} />
                <View style={styles.logo}>
                    <Image
                        source={{ uri: 'https://shop.bikermobile.com/assets/biker_mobile_logo_final_nobg.png' }}
                        height={100} width={100}
                    />
                </View>
                <Space height={48} />
                <Title style={styles.title}>{content.about.welcome}{osName}</Title>
                <Space height={48} />
                <Description style={styles.description}>
                    {content.about.appVersion}{AppConfig.appVersionNumber}
                </Description>
                <Space height={48} />
                <Description style={styles.description}>
                    {content.about.copyright}
                </Description>
            </View>
        </SafeAreaView>
    )

}

const styles = StyleSheet.create({
  logo: {
    alignSelf: 'center'
  },
  title: {
    color: colors.brightOrange,
    ...typography.demi,
    marginLeft: 30,
    marginRight: 30
  },
  description: {
    textAlign: 'center',
    color: colors.white,
    ...typography.demi,
  }
})
